import template from './sw-cms-el-acris-blog-group.html.twig';
import './sw-cms-el-acris-blog-group.scss';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('sw-cms-el-acris-blog-group', {
    template,

    inject: [
        'repositoryFactory',
    ],

    mixins: [
        Mixin.getByName('cms-element')
    ],

    data() {
        return {
            groups: null
        }
    },

    computed: {
        groupRepository() {
            return this.repositoryFactory.create('acris_blog_group');
        },

        currentGroupIds() {
            return this.element?.config?.groups?.value ?? [];
        },

        assetFilter() {
            return Shopware.Filter.getByName('asset');
        }
    },

    watch: {
        currentGroupIds() {
            this.getGroups();
        }
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.initElementConfig('acris-blog-group');

            this.getGroups();
        },

        getGroups() {
            const criteria = new Criteria();
            criteria.setIds(this.element.config.groups.value);

            this.groupRepository.search(criteria).then((result) => {
                this.groups = result.total > 0 ? result : [];
            });
        }
    }
});
